// Regras puras do Suporte AMShift, separadas dos componentes para serem testadas sozinhas.

// Os mesmos limites do helpdesk (e do Rails do Fluxi).
export const MAXIMO_DE_ANEXOS = 5;
export const BYTES_POR_ANEXO = 10 * 1024 * 1024;
export const EXTENSOES_ACEITAS = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'pdf',
  'txt',
  'csv',
  'log',
  'xml',
  'json',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'odt',
  'ods',
  'zip',
];

const extensaoDe = nome => (nome.split('.').pop() || '').toLowerCase();

const doisDigitos = numero => String(numero).padStart(2, '0');

// Print colado vem sem nome útil ("image.png"): dá um nome que diz o que é,
// com a hora local de quem colou.
export const nomearPrintColado = (arquivo, agora = new Date()) => {
  const extensao = (arquivo.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
  const carimbo = [
    agora.getFullYear(),
    agora.getMonth() + 1,
    agora.getDate(),
    agora.getHours(),
    agora.getMinutes(),
    agora.getSeconds(),
  ]
    .map(doisDigitos)
    .join('-');
  return new File([arquivo], `print-${carimbo}.${extensao}`, {
    type: arquivo.type,
  });
};

/**
 * Junta os novos arquivos aos já escolhidos, respeitando os limites.
 * Devolve os aceitos e os motivos de recusa (chaves de i18n com parâmetros).
 */
export const adicionarAnexos = (atuais, novos) => {
  const aceitos = [...atuais];
  const recusas = [];
  novos.forEach(arquivo => {
    if (aceitos.length >= MAXIMO_DE_ANEXOS) {
      recusas.push({ chave: 'LIMITE', nome: arquivo.name });
    } else if (!EXTENSOES_ACEITAS.includes(extensaoDe(arquivo.name))) {
      recusas.push({ chave: 'TIPO', nome: arquivo.name });
    } else if (arquivo.size > BYTES_POR_ANEXO) {
      recusas.push({ chave: 'TAMANHO', nome: arquivo.name });
    } else {
      aceitos.push(arquivo);
    }
  });
  return { aceitos, recusas };
};

// Empresa e solicitante não vão daqui: o Rails tira da sessão.
export const montarFormDataDoChamado = (campos, anexos) => {
  const formData = new FormData();
  ['tipo', 'prioridade', 'titulo', 'descricao', 'tela'].forEach(campo => {
    if (campos[campo]) formData.append(campo, campos[campo]);
  });
  anexos.forEach(arquivo => formData.append('anexos[]', arquivo));
  return formData;
};

export const montarFormDataDaResposta = (corpo, anexos) => {
  const formData = new FormData();
  formData.append('corpo', corpo);
  anexos.forEach(arquivo => formData.append('anexos[]', arquivo));
  return formData;
};

// O prazo que importa agora: o da 1ª resposta até ela acontecer; depois, o da solução.
export const prazoAtual = chamado => {
  const { sla } = chamado || {};
  if (!sla) return null;
  if (sla.pausado) return { ...sla.solucao, situacao: 'pausado' };
  return sla.resposta?.situacao === 'cumprido' ? sla.solucao : sla.resposta;
};

export const COR_DA_SITUACAO = {
  no_prazo: 'bg-n-teal-3 text-n-teal-11',
  em_risco: 'bg-n-amber-3 text-n-amber-11',
  violado: 'bg-n-ruby-3 text-n-ruby-11',
  pausado: 'bg-n-slate-3 text-n-slate-11',
  cumprido: 'bg-n-slate-3 text-n-slate-11',
};

export const mensagemDoErro = (erro, padrao) =>
  erro?.response?.data?.error || padrao;

export const formatarDataHora = (iso, locale) =>
  iso
    ? new Date(iso).toLocaleString(locale.replace('_', '-'), {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : '';
